import { render, staticRenderFns } from "./ContestMyVerticalSeries.vue?vue&type=template&id=60a42ac2"
import script from "./ContestMyVerticalSeries.vue?vue&type=script&lang=js"
export * from "./ContestMyVerticalSeries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports